export default "__VITE_ASSET__BXbI5KjE__"